<div class="applicationColor" style="text-align: center">
  <h2>{{ 'LOA_PreparingPaymnent' | t | async }}</h2>
</div>
